module.exports = __webpack_public_path__ + "media/images/logos/lowrance-lg-abfac78165a6b1f4d24d505510ebe15d.png";